import React from 'react'
import Container from '../../components/Container';
import {Window, Header, WindowTool, FileButton, FileButtonUpload, HeaderTool, SendButton, InfoBar} from './styled';
import Croppie from "croppie";
import "croppie/croppie.css";
import Input from '../../components/Form/Input';
import useForm from '../../hooks/useForm';
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Fade,
    Modal,
    Tooltip
} from '@material-ui/core';
import {AiFillQuestionCircle} from 'react-icons/ai';
import {withStyles, makeStyles, createStyles} from '@material-ui/core/styles';
import SaveIcon from '@material-ui/icons/Save';
import Button from '@material-ui/core/Button';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import {InputStyled, Label} from '../../components/Form/Input/styled';
import {CgSize} from 'react-icons/cg';
import AspectRatioIcon from '@material-ui/icons/AspectRatio';
import ImageIcon from '@material-ui/icons/Image';
import {MdClose} from 'react-icons/md';
import {blue} from '@material-ui/core/colors';
import Backdrop from '@material-ui/core/Backdrop';
import {api} from '../../services/api';
import {UserContext} from '../../UserContext';
import Alert from '../../components/Alert';

export interface SimpleDialogProps {
    open: boolean;
    selectedValue: string;
    onClose: (value: string) => void;
}

const nameToolTip = `
    Se o nome escolhido conter espaços ou caracteres especiais, os mesmos serão substituidos por "_". 
    O nome ao lado já está limpo automaticamente. O Formato de saída é JPG, e não é possível altera-lo.
`;

const qualidadeToolTip = `
    A qualidade recomendada é 7, abaixo de 5 a imagem começará a ficar com uma qualidade muito ruim. 
`;

const LightTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: theme.palette.common.white,
        color: 'rgba(0, 0, 0, 0.87)',
        boxShadow: theme.shadows[1],
        fontSize: 11,
        padding: '20px'
    },
}))(Tooltip);

const useStyles = makeStyles((theme) =>
    createStyles({
        root: {
            boxShadow: 'none',
        },
        media: {
            height: 140,
        },
        modal: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
        paper: {
            backgroundColor: '#F1F1F1',
            boxShadow: theme.shadows[5],
        },
        exit: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            padding: '5px 10px',
        },
        avatar: {
            backgroundColor: blue[100],
            color: blue[600],
        },
        button: {
            margin: theme.spacing(1),
        },
    }),
);

function formatBytes(bytes: number, decimals = 2) {
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}

const SendImages: React.FC = () => {
    document.title = "Enviar Imagens - Sultan Veste a Casa";

    const [image, setImage] = React.useState("");
    const [blob, setBlob] = React.useState("");
    const [nameImage, setNameImage] = React.useState("");
    const [size, setSize] = React.useState("");
    const [quality, setQuality] = React.useState("7");
    const [croppie, setCroppie] = React.useState<Croppie | null>(null)
    const [open, setOpen] = React.useState(false);
    const [openDialog, setOpenDialog] = React.useState(false);
    const [error, setError] = React.useState("");
    const [success, setSuccess] = React.useState('');

    const {setLoading} = React.useContext(UserContext);

    const name = useForm('nameFile');

    const classes = useStyles();

    const LoadCroppie = React.useCallback(() => {
        const el = document.getElementById("image-helper");
        if (el) {
            const croppieInstance = new Croppie(el, {
                enforceBoundary: false,
                enableOrientation: true,
                showZoomer: false,
                viewport: {
                    width: 850,
                    height: 480,
                    type: 'square',
                },
                boundary: {
                    width: 850,
                    height: 480,
                },
                enableExif: true,

            });

            setCroppie(croppieInstance);

            el.addEventListener("update", (resp) => {
                const qualidadeInput = document.getElementById("qualidade-hidden");
                if (qualidadeInput === null) return;

                const value = qualidadeInput.getAttribute("value");
                if (value === null) return;

                croppieInstance.result({
                    type: 'canvas',
                    quality: getQualityValue(parseFloat(value)),
                    format: 'jpeg',
                    backgroundColor: '#ffffff'
                }).then(function (resp) {
                    let base64Length = resp.length - (resp.indexOf(',') + 1);
                    let padding = (resp.charAt(resp.length - 2) === '=') ? 2 : ((resp.charAt(resp.length - 1) === '=') ? 1 : 0);
                    let fileSize = base64Length * 0.75 - padding;

                    setSize(formatBytes(fileSize, 1));
                });
                // console.log(fileSize)
            });
        }
    }, []);
    

    React.useEffect(() => {
        LoadCroppie();
        // eslint-disable-next-line
    }, []);

    const handleClose = () => {
        setOpen(false);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
    };

    const handleOpenImage = () => {
        if (croppie !== null) {
            croppie.result({
                type: 'canvas',
                quality: getQualityValue(parseFloat(quality)),
                format: 'jpeg',
                backgroundColor: '#ffffff'
            }).then((blob) => {
                setBlob(blob);
            })
            console.log(blob)
        }
        setOpen(true);
    };

    const getQualityValue = (value: number) => value === 10 ? 1 : value / 10;

    const handleImage = (image: string) => {
        setImage(image);

        if (!croppie) return;
        croppie.bind({
            url: image,
        });
    }

    const convertBase64 = (file: any) => {
        return new Promise<any>((resolve, reject) => {
            const fileReader = new FileReader();
            fileReader.readAsDataURL(file)
            fileReader.onload = () => {
                resolve(fileReader.result);
            }
            fileReader.onerror = (error) => {
                reject(error);
            }
        })
    }

    const handleSubmit = async (event: any) => {
        event.preventDefault();

        if (croppie !== null) {
            const blobResponse = await croppie.result({
                type: 'base64',
                size: {
                    width: 850,
                    height: 480
                },
                format: 'jpeg',
                backgroundColor: '#ffffff'
                
            });

            const target = document.querySelector('input[type="file"]') as HTMLInputElement;
            if (!target) return;

            const arquivo: File = (target.files as FileList)[0];

            const bodyFormData = new FormData();
            bodyFormData.append('file', arquivo);
            bodyFormData.append('name', name.value);
            bodyFormData.append('base64', blobResponse);
            console.log("blob"+blobResponse);
            try {
                setLoading(true);

                const {data} = await api.post('/repository',
                
                    bodyFormData,
                    {
                        headers: {"Content-Type": "multipart/form-data"}
                        
                    }
                );
                console.log(data)
                setSuccess(data.message);
            } catch (error) {
                const result = (error as Error).message;
                setError(result);
            } finally {
                setLoading(false);
                handleCloseDialog();
            }
        }
        
        
    }

    const handleFileRead = async (e: any) => {
        if (!e.target.files[0]) return;

        const file = e.target.files[0];

        if(file.type !== 'image/jpeg'){
            setError('Envie uma imagem em JPG!');
            return;
        }

        var nameFile = file.name.replace(/\.(.*)/g, '');
        nameFile = nameFile.replace(/[^a-zA-Z0-9]/gi, '_');

        setNameImage(nameFile);

        name.setValue(nameFile);

        const base64 = await convertBase64(file);
        handleImage(base64);
    }

    const handleClickOpen = () => {
        setOpenDialog(true);
    };  

    const handleQuality = (e: React.ChangeEvent<HTMLInputElement>) => {
        setQuality(e.target.value);

        if (!croppie) return;

        const qualidadeInput = document.getElementById("qualidade");
        if (qualidadeInput === null) return;

        croppie.result({
            type: 'canvas',
            quality: getQualityValue(parseFloat(e.target.value)),
            format: 'jpeg',
            backgroundColor: '#ffffff'
        }).then(function (resp) {
            let base64Length = resp.length - (resp.indexOf(',') + 1);
            let padding = (resp.charAt(resp.length - 2) === '=') ? 2 : ((resp.charAt(resp.length - 1) === '=') ? 1 : 0);
            let fileSize = base64Length * 0.75 - padding;

            setSize(formatBytes(fileSize, 1));
        });
    }

    const handleMessageSuccess = () => {
        setSuccess('');
    }

    const handleMessageError = () => {
        setError('');
    }

    return (
        <Container>
            <WindowTool className="shadow">
                <Header>
                    <span>{!nameImage ? 'Nenhum arquivo selecionado' : nameImage}</span>
                    <FileButton>
                        <Button
                            variant="contained"
                            color="primary"
                            size="large"
                            className={classes.button}
                            startIcon={<CloudUploadIcon/>}
                        >
                            {image !== "" ? 'Escolher Outra' : 'Selecionar Arquivo'}
                        </Button>
                        <FileButtonUpload id="file" accept="image/jpeg" type="file" onChange={handleFileRead}/>
                    </FileButton>
                </Header>
            </WindowTool>
            <Window>
                <div id="image-helper"></div>
                {image !== "" && (
                    <>
                        <WindowTool className="toolbar">
                            <InfoBar>
                                <div>
                                    <CgSize size={20}/>
                                    <span>Tamanho: {size}</span>
                                </div>
                                <div>
                                    <AspectRatioIcon fontSize="small"/>
                                    <span>850 x 480</span>
                                </div>
                            </InfoBar>
                            <HeaderTool>
                                <div style={{display: 'flex'}}>
                                    <Input label="Nome do arquivo: " required id="name" type="text" {...name}/>
                                    <LightTooltip className="pointer" title={nameToolTip}>
                                        <div>
                                            <AiFillQuestionCircle size={28}/>
                                        </div>
                                    </LightTooltip>
                                </div>
                                <div style={{display: 'flex'}}>
                                    <div>
                                        <Label htmlFor="quality">Qualidade, de 1 a 10, Padrão = 7:</Label>
                                        <InputStyled required onChange={handleQuality} id="qualidade" min="1"
                                                     value={quality} max="10" type="number"/>
                                        <input id="qualidade-hidden" value={quality} type="hidden"/>
                                    </div>
                                    <LightTooltip className="pointer" title={qualidadeToolTip}>
                                        <div>
                                            <AiFillQuestionCircle size={28}/>
                                        </div>
                                    </LightTooltip>
                                </div>
                                <SendButton>
                                    <Button
                                        variant="contained"
                                        color="default"
                                        size="large"
                                        className={classes.button}
                                        startIcon={<ImageIcon/>}
                                        onClick={handleOpenImage}
                                    >
                                        Resultado
                                    </Button>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        size="large"
                                        className={classes.button}
                                        startIcon={<SaveIcon/>}
                                        onClick={handleClickOpen}
                                    >
                                        SALVAR
                                    </Button>
                                </SendButton>
                            </HeaderTool>
                        </WindowTool>
                        <Modal
                            aria-labelledby="transition-modal-title"
                            aria-describedby="transition-modal-description"
                            className={classes.modal}
                            open={open}
                            onClose={handleClose}
                            closeAfterTransition
                            BackdropComponent={Backdrop}
                            BackdropProps={{
                                timeout: 500,
                            }}
                        >
                            <Fade in={open}>
                                <div className={classes.paper}>
                                    <div className={classes.exit}>
                                        <MdClose className="pointer" size={40} onClick={handleClose}/>
                                    </div>
                                    <img src={blob} alt="Imagem do Modal"/>
                                </div>
                            </Fade>
                        </Modal>
                        <Dialog
                            open={openDialog}
                            onClose={handleCloseDialog}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                        >
                            <DialogTitle id="alert-dialog-title">{"Janela de Confirmação"}</DialogTitle>
                            <DialogContent>
                                <DialogContentText id="alert-dialog-description">
                                    Já fez todas as edições ? Se sim, clique em "Salvar".
                                </DialogContentText>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={handleCloseDialog} color="primary">
                                    CANCELAR
                                </Button>
                                <Button onClick={handleSubmit} color="primary" autoFocus>
                                    SALVAR
                                </Button>
                            </DialogActions>
                        </Dialog>                        
                    </>
                )}
            </Window>       
            <Alert open={success !== ''} onClose={handleMessageSuccess} severity="success" message={success}/>
            <Alert open={error !== ''} onClose={handleMessageError} severity="error" message={error}/>
        </Container>
    )
}

export default SendImages;